// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2136":"rrule","4328":"Widgets","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"2136":"4bcd07cf","4328":"ac119948","5772":"ac119948"}[chunkId] + ".chunk.css";
};